<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">
                <ng-container *ngIf="data?.subscription; else titleNewSubscription">
                    {{ 'person.invoices.subscriptions.dialogTitleEdit' | translate }}
                </ng-container>
                <ng-template #titleNewSubscription>
                    {{ 'person.invoices.subscriptions.add' | translate }}
                </ng-template>
            </h2>
            <button data-test="B-Close-dialog" mat-icon-button (click)="dialogRef.close()"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="p-16 p-sm-24 m-0" fusePerfectScrollbar>

        <form [formGroup]="formGroup">

            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                    <mat-label>{{ 'dialogs.productSubscription.paymentIntervalLabel' | translate }}</mat-label>
                    <mat-select data-test="FS-Zahlungsintervall" formControlName="payableOption"
                                [compareWith]="comparePayableOptions">
                        <mat-option *ngFor="let payableOption of payableOptions" [value]="payableOption">
                            {{ payableOption.translationKey | translate }}
                        </mat-option>
                    </mat-select>
                    <mat-error>{{ formGroup.get('payableOption').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>
            </div>

            <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                <br>
                <strong>
                    {{ 'dialogs.productSubscription.recurringPaymentHeader' | translate }}
                    <ng-container *ngIf="formGroup.get('payableOption').value?.translationKey as pk">
                        <span style="text-transform: lowercase;">
                            - {{ pk | translate }}
                        </span>
                    </ng-container>
                </strong>
            </div>

            <h3 [innerHTML]="'dialogs.productSubscription.headlineFirstPositionHtml' | translate"></h3>
            <app-input-date-time formControlName="fromDate">
                <label>{{ 'dialogs.productSubscription.labelFirstPosition' | translate }}</label>
            </app-input-date-time>

            <h3 [innerHTML]="'dialogs.productSubscription.headlineLastPositionHtml' | translate"></h3>

            <app-input-date-time formControlName="toDate">
                <label>{{ 'dialogs.productSubscription.labelLastPosition' | translate }}</label>
            </app-input-date-time>

            <div fxLayout="column" fxLayoutAlign="start start" class="mb-8">
                <h2>{{ 'dialogs.productSubscription.firstServicePeriodHeading' | translate }}</h2>
                <p>
                    {{ 'dialogs.productSubscription.firstServicePeriodIntro' | translate }}
                    <ng-container *ngIf="formGroup.get('payableOption').value?.translationKey; else other">
                        <strong style="text-transform: lowercase;">{{ formGroup.get('payableOption').value?.translationKey | translate }}</strong>
                    </ng-container>
                    <ng-template #other>{{ 'dialogs.productSubscription.inSelectedPayableInterval' | translate }}</ng-template>
                    {{ 'dialogs.productSubscription.servicePeriodRegeneratedSuffix' | translate }}
                </p>
            </div>

            <ng-container
                    *ngIf="formGroup.get('payableOption')?.value?.id === PayableOptionId.Yearly && seasons?.length">
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-form-field appearance="outline" floatLabel="always" fxFlex>
                        <mat-label>{{ 'dialogs.productSubscription.seasonsMatLabel' | translate }}</mat-label>
                        <mat-select data-test="FS-Saisons"
                                    [formControl]="seasonFormControl"
                                    [compareWith]="compareSeasons">
                            <mat-option [value]="null">{{ 'dialogs.productSubscription.noSeasonOption' | translate }}</mat-option>
                            <mat-option *ngFor="let season of seasons" [value]="season">
                                {{ season.name }} / {{ season.startDate | dfnsFormat : 'dd.MM.yyyy' }} -
                                {{ season.endDate | dfnsFormat : 'dd.MM.yyyy' }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </ng-container>

            <app-input-date-time formControlName="vestingPeriodFrom">
                <label>{{ 'dialogs.productSubscription.vestingPeriodStart' | translate }}</label>
            </app-input-date-time>

            <app-input-date-time formControlName="vestingPeriodUntil">
                <label>{{ 'dialogs.productSubscription.vestingPeriodEnd' | translate }}</label>
            </app-input-date-time>

            <ng-container
                    *ngIf="[PayableOptionId.Monthly, PayableOptionId.HalfYearly, PayableOptionId.QuarterYearly].includes(formGroup.get('payableOption')?.value?.id)">
                <div fxLayout="row" fxLayoutAlign="start start">
                    <mat-checkbox formControlName="lastDayOfMonth">
                        {{ 'dialogs.productSubscription.lastDayOfMonthCheckbox' | translate }}
                    </mat-checkbox>
                </div>
            </ng-container>

        </form>

    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="space-between center">

        <ng-container *ngIf="data.subscription; else newSubscription">
            <button data-test="B-Abo entfernen" mat-flat-button
                    color="warn"
                    (click)="dialogRef.close(false)"
                    class="save-button"
                    [attr.aria-label]="'common.remove' | translate">
                {{ 'dialogs.productSubscription.removeSubscription' | translate }}
            </button>

            <button data-test="B-Abo speichern" mat-flat-button
                    color="accent"
                    (click)="saveAndContinue()"
                    class="save-button"
                    [disabled]="isSaving || !formGroup.dirty"
                    [attr.aria-label]="'common.save' | translate">
                {{ 'dialogs.productSubscription.saveSubscription' | translate }}
            </button>
        </ng-container>

        <ng-template #newSubscription>
            <button data-test="B-Abo hinzufügen" mat-flat-button
                    color="accent"
                    (click)="saveAndContinue()"
                    class="save-button"
                    [disabled]="isSaving || !formGroup.dirty"
                    [attr.aria-label]="'common.save' | translate">
                {{ 'person.invoices.subscriptions.add' | translate }}
            </button>
        </ng-template>

    </div>
</div>
